export const customGetDevice = /* GraphQL */ `
  query GetDevice($id: ID!) {
    getDevice(id: $id) {
      id
      name
      location
      brand
      description
      companyID
      branchID
      coordsLat
      coordsLng
      timezone
      energyCost
      currency
      actionOnOff
      autoRefreshTime
      alerts {
        items {
          id
          alert {
            id
            name
          }
        }
      }
      env
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const customGetRule = /* GraphQL */ `
  query GetRule($id: ID!) {
    getRule(id: $id) {
      id
      name
      description
      action
      actionValue
      devices {
        items {
          id
          device {
            id
            name
          }
        }
      }
      smsNotifications
      wspNotifications
      emailNotifications
      conditions
      companyID
      startSchedule
      endSchedule
      days
      execInterval
      execTime
      hourInterval
      executeOnHolidays
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const customGetAlert = /* GraphQL */ `
  query GetAlert($id: ID!) {
    getAlert(id: $id) {
      id
      name
      description
      severity
      severityColor
      devices {
        items {
          id
          device {
            id
            name
          }
        }
      }
      smsNotifications
      wspNotifications
      emailNotifications
      conditions
      companyID
      startSchedule
      endSchedule
      days
      execInterval
      execTime
      hourInterval
      executeOnHolidays
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const customGetRole = /* GraphQL */ `
  query GetRole($id: ID!) {
    getRole(id: $id) {
      id
      name
      description
      permissions(limit: 500) {
        items {
          id
          permission {
            id
            name
            description
          }
        }
      }
      users {
        items {
          id
          user {
            id
            email
          }
        }
      }
      companyID
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const getUserEmail = /* GraphQL */ `
  query GetUserEmail($id: ID!) {
    getUser(id: $id) {
      id
      email
      __typename
    }
  }
`;

export const getCompanyName = /* GraphQL */ `
  query GetCompanyName($id: ID!) {
    getCompany(id: $id) {
      id
      name
      __typename
    }
  }
`;

export const getVariableName = /* GraphQL */ `
  query GetVariableName($id: ID!) {
    getVariable(id: $id) {
      id
      name
      __typename
    }
  }
`;

export const getBranchName = /* GraphQL */ `
  query GetBranchName($id: ID!) {
    getBranch(id: $id) {
      id
      name
      __typename
    }
  }
`;

export const getDeviceName = /* GraphQL */ `
  query GetDeviceName($id: ID!) {
    getDevice(id: $id) {
      id
      name
      __typename
    }
  }
`;

export const getEquipmentName = /* GraphQL */ `
  query GetEquipmentName($id: ID!) {
    getEquipment(id: $id) {
      id
      name
      __typename
    }
  }
`;

export const getServiceOrderCode = /* GraphQL */ `
  query GetServiceOrderCode($id: ID!) {
    getServiceOrder(id: $id) {
      id
      code
      __typename
    }
  }
`;

export const customUserBySub = /* GraphQL */ `
  query UserBySub(
    $sub: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userBySub(
      sub: $sub
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        sub
        roles {
          items {
            role {
              id
              name
              permissions(limit: 500) {
                items {
                  permission {
                    name
                    description
                  }
                }
              }
            }
          }
        }
        name
        birthDate
        position
        sex
        gender
        phones
        additionalEmails
        addresses
        companyID
        isSuper
        isTechnician
        photoSrc
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const customGetUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      email
      sub
      roles {
        items {
          role {
            id
            name
            permissions(limit: 500) {
              items {
                permission {
                  name
                  description
                }
              }
            }
          }
        }
      }
      name
      birthDate
      position
      sex
      gender
      phones
      additionalEmails
      addresses
      companyID
      isSuper
      isTechnician
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const customListCompaniesByNit = /* GraphQL */ `
  query ListCompanies(
    $filter: ModelCompanyFilterInput
  ) {
    listCompanies(filter: $filter) {
      items {
        nit
      }
    }
  }
`;